import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import PersonMiniForm from "./PersonMiniForm";
import CompanyMiniForm from "./CompanyMiniForm";

const ContactMiniForm = ({ defaultType = "person" }) => {
  const [contactType, setContactType] = useState(defaultType);
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          gap: "0.5rem",
          border: "1px solid #e5e5e5",
          p: "0.2rem",
          borderRadius: "0.5rem",
          width: "fit-content",
          m: "1rem",
        }}
      >
        <Button
          variant={contactType === "person" ? "contained" : "text"}
          startIcon={<AccountCircleRoundedIcon />}
          sx={{ textTransform: "capitalize", fontSize: "0.8rem" }}
          onClick={() => setContactType("person")}
          size="small"
        >
          Person
        </Button>
        <Button
          variant={contactType === "company" ? "contained" : "text"}
          startIcon={<BusinessRoundedIcon />}
          sx={{ textTransform: "capitalize", fontSize: "0.8rem" }}
          onClick={() => setContactType("company")}
          size="small"
        >
          Company
        </Button>
      </Box>
      {contactType === "person" ? <PersonMiniForm /> : <CompanyMiniForm />}
    </Box>
  );
};

export default ContactMiniForm;
